import styled from "styled-components";

export const EditContainer = styled.div`
    background-color: white;
    padding: 24px;
`;
